module.exports = __webpack_public_path__ + "static/img/pageBg.f9f9dcd5.png";